<div *ngIf="loadindData$ | async; else contentData" class="loading-indicator-wrapper">
  <cbre-spinner-loading-indicator diameter="48"></cbre-spinner-loading-indicator>
</div>
<ng-template #contentData>
  <form [formGroup]="floorsFG" class="floors-wrapper">
    <!-- GENERAL FORM -->
    <div formGroupName="general" class="floors-header">
      <div class="floors__forms">
        <div class="floors__forms__item form-container fx--mb-sm">
          <label>{{ 'moreInfo.nra' | xTranslate }}</label>
          <div
            class="form-container__item optselect"
            formGroupName="propertyNRA"
            [class.error]="!!generalFormGroup.controls.propertyNRA.errors"
          >
            <input
              miqOnlyNumbers
              [restrictPaste]="false"
              type="text"
              class="text-input fx--flex1"
              name="floors-nra"
              formControlName="val"
            />
            <mat-form-field class="mat-select-field fx--flex1 miq-form-input" floatLabel="never" appearance="outline">
              <mat-select
                hideSingleSelectionIndicator="true"
                #uomSelect
                [placeholder]="'commonLabels.select' | xTranslate"
                panelClass="custom-dropdown"
                name="uomValue"
                formControlName="uom"
                (focus)="uomSelect.open()"
                panelWidth
              >
                <mat-option (click)="uomSelect.close()">--</mat-option>
                <mat-option *ngFor="let uom of uomValues" [value]="uom.key" (click)="uomSelect.close()">
                  {{ uom.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <ng-container
            *ngTemplateOutlet="generalErrorMsgs; context: { control: generalFormGroup.controls.propertyNRA }"
          ></ng-container>
        </div>
        <div class="floors__forms__item form-container fx--mb-sm">
          <label>
            {{ 'moreInfo.floorCommonSize' | xTranslate }}
            <mat-icon
              class="tooltip-icon"
              svgIcon="tooltip"
              [matTooltip]="'moreInfo.commonFloorSizeInfo' | xTranslate"
              matTooltipClass="tooltip-custom"
              matTooltipPosition="right"
            ></mat-icon>
          </label>
          <div
            class="form-container__item optselect"
            formGroupName="propertyCommonFloorSize"
            [class.error]="!!generalFormGroup.controls?.propertyCommonFloorSize?.errors"
            [class.warning]="
              !generalFormGroup.controls?.propertyCommonFloorSize?.errors &&
              asWarn(generalFormGroup.controls?.propertyCommonFloorSize)?.warnings
            "
          >
            <input
              miqOnlyNumbers
              [restrictPaste]="false"
              type="text"
              class="text-input fx--flex1"
              name="floorsFloorCommonSize"
              formControlName="val"
            />
            <mat-form-field class="mat-select-field fx--flex1 miq-form-input" floatLabel="never" appearance="outline">
              <mat-select
                hideSingleSelectionIndicator="true"
                #cmSelect
                [placeholder]="'commonLabels.select' | xTranslate"
                panelClass="custom-dropdown"
                name="uomValue"
                formControlName="uom"
                (focus)="cmSelect.open()"
                panelWidth
              >
                <mat-option (click)="cmSelect.close()">--</mat-option>
                <mat-option *ngFor="let uom of uomValues" [value]="uom.key" (click)="cmSelect.close()">
                  {{ uom.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <ng-container
            *ngTemplateOutlet="
              generalErrorMsgs;
              context: { control: generalFormGroup.controls.propertyCommonFloorSize }
            "
          ></ng-container>
        </div>
        <div class="floors__forms__item form-container second-row fx--mb-sm">
          <label>{{ 'moreInfo.floorsAboveGround' | xTranslate }}</label>
          <div
            class="form-container__item"
            [class.error]="generalFormGroup.controls.numberOfFloors.errors"
            [class.warning]="
              !generalFormGroup.controls.numberOfFloors.errors &&
              asWarn(generalFormGroup.controls.numberOfFloors).warnings
            "
          >
            <input
              type="number"
              name="numberOfFloors"
              formControlName="numberOfFloors"
              class="text-input"
              min="0"
              (keydown)="preventSignKeys($event)"
              (blur)="updateFloorsPositions()"
            />
          </div>
          <ng-container
            *ngTemplateOutlet="generalErrorMsgs; context: { control: generalFormGroup.controls.numberOfFloors }"
          ></ng-container>
        </div>
        <div class="floors__forms__item form-container second-row fx--mb-sm">
          <label>{{ 'moreInfo.ugFloors' | xTranslate }}</label>
          <div
            class="form-container__item"
            [class.error]="generalFormGroup.controls.underGroundFloors.errors"
            [class.warning]="
              !generalFormGroup.controls.underGroundFloors.errors &&
              asWarn(generalFormGroup.controls.underGroundFloors).warnings
            "
          >
            <input
              type="number"
              name="underGroundFloors"
              class="text-input"
              formControlName="underGroundFloors"
              min="0"
              (keydown)="preventSignKeys($event)"
              (blur)="updateFloorsPositions()"
            />
          </div>
          <ng-container
            *ngTemplateOutlet="generalErrorMsgs; context: { control: generalFormGroup.controls.underGroundFloors }"
          ></ng-container>
        </div>
      </div>
    </div>
    <!-- FLOOR ACTIONS -->
    <div class="floor-actions" #moveOrigin>
      <sp-floors-actions
        [selectedFloorGroup]="selectedFloors"
        [elevatorSelectedFloors]="elevatorSelectedFloors"
        [uploadingFloorPlan]="uploadingFloorPlan"
        [isMoveFloorOverlayOpen]="moveFloorStatus"
        [generalCommonFloorSizeFG]="generalCommonFloorSizeFG"
        [floorsAboveGround]="generalFormGroup.get('numberOfFloors').value"
        [floorsBelowGround]="generalFormGroup.get('underGroundFloors').value"
        (onFileChange)="onFileChange($event)"
        (toggleHiddenFloor)="toggleHiddenFloor($event)"
        (moveFloorEmitter)="showDetailsOverlay(moveOrigin)"
        (deleteFloorEmitter)="deleteFloorOverlay(moveOrigin)"
        (updateCommonFloorSize)="updateFloorSize()"
      ></sp-floors-actions>
    </div>
    <!-- FLOOR LIST TABLE -->
    <div class="table-content">
      <p-table
        class="p-datatable-custom"
        [(selection)]="selectedFloors"
        [value]="floors"
        [columns]="floorHeaders"
        selectionMode="multiple"
        formArrayName="floor"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns; index as i" [ngClass]="col.headerClass" scope="col">
              <span>{{ col.header | xTranslate }}</span>
              <mat-checkbox *ngIf="i === 0" (change)="selectAllFloors($event)" [checked]="areAllFloorsChecked">
              </mat-checkbox>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-floor let-floorIndex="rowIndex">
          <!-- floorIndex being used to retrieve form group from form array -->
          <tr [formGroupName]="floorIndex">
            <td class="floorSelection">
              <p-tableCheckbox
                (click)="floorChecked()"
                [value]="{ floorGroup: floorFormArray.controls[floorIndex], floorIndex: floorIndex }"
              ></p-tableCheckbox>
            </td>
            <td *cbreTogglePoint="showFloorIndexFeatureKey">
              <!-- THIS TOGGLE POINT is intentionally added to help developers to see the actual floor index of the floor (Will not be displayed in any environment but local) -->
              {{ (floorFormArray | getFloorFGAt: floorIndex)?.value.floorIndex }}
            </td>
            <td class="floor__num" [class.disabled]="(floorFormArray | getFloorFGAt: floorIndex)?.value.hideFloor">
              <input
                class="floor-number"
                type="text"
                name="floorNumber"
                formControlName="floorNumber"
                [placeholder]="(floorFormArray | getFloorFGAt: floorIndex)?.value.floorIndex"
                [class.error]="(floorFormArray | getFloorFGAt: floorIndex).errors"
                [class.disabled]="floor | isFloorIndexEqualToInvalidIndexValue"
              />
              <mat-icon
                *ngIf="!(floor | isFloorIndexValid)"
                class="help"
                [matTooltip]="
                  ((floor | isFloorIndexEqualToInvalidIndexValue)
                    ? 'moreInfo.floorNumberInvalidTooltip'
                    : 'moreInfo.floorNumberTooBigTooltip'
                  ) | xTranslate
                "
                matTooltipClass="tooltip-custom"
                matTooltipPosition="above"
                svgIcon="tooltip"
              ></mat-icon>
              <ng-container
                *ngTemplateOutlet="generalErrorMsgs; context: { control: (floorFormArray | getFloorFGAt: floorIndex) }"
              ></ng-container>
            </td>
            <td class="floor__name" [class.disabled]="(floorFormArray | getFloorFGAt: floorIndex)?.value.hideFloor">
              <input type="text" name="floorName" formControlName="floorName" />
            </td>
            <td class="floor__size-uom" [class.disabled]="(floorFormArray | getFloorFGAt: floorIndex)?.value.hideFloor">
              <div class="floors__forms__item form-container">
                <div class="form-container__item optselect" formGroupName="floorGrossArea">
                  <input
                    miqOnlyNumbers
                    [restrictPaste]="false"
                    class="floor-size"
                    type="number"
                    min="0"
                    name="totalGrossArea"
                    formControlName="val"
                  />
                  <mat-form-field
                    class="mat-select-field mat-form-field miq-form-input"
                    floatLabel="never"
                    appearance="outline"
                  >
                    <mat-select
                      hideSingleSelectionIndicator="true"
                      #faGrossAreaSelect
                      [placeholder]="'commonLabels.select' | xTranslate"
                      panelClass="custom-dropdown"
                      name="totalGrossAreaUOM"
                      formControlName="uom"
                      (focus)="faGrossAreaSelect.open()"
                      panelWidth
                    >
                      <mat-option (click)="faGrossAreaSelect.close()">--</mat-option>
                      <mat-option *ngFor="let uom of uomValues" [value]="uom.key" (click)="faGrossAreaSelect.close()">
                        {{ uom.value }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <ng-container
                    *ngTemplateOutlet="
                      generalErrorMsgs;
                      context: { control: (floorFormArray | getFloorFGAt: floorIndex).controls.floorGrossArea }
                    "
                  ></ng-container>
                </div>
              </div>
            </td>
            <td class="floor__size-uom" [class.disabled]="(floorFormArray | getFloorFGAt: floorIndex)?.value.hideFloor">
              <div class="floors__forms__item form-container">
                <div class="form-container__item optselect" formGroupName="floorSize">
                  <input
                    class="floor-size"
                    miqOnlyNumbers
                    [restrictPaste]="false"
                    type="number"
                    min="0"
                    name="floorArea"
                    formControlName="val"
                  />
                  <mat-form-field
                    class="mat-select-field mat-form-field miq-form-input"
                    floatLabel="never"
                    appearance="outline"
                  >
                    <mat-select
                      hideSingleSelectionIndicator="true"
                      #faSelect
                      [placeholder]="'commonLabels.select' | xTranslate"
                      panelClass="custom-dropdown"
                      name="floorAreaUOM"
                      formControlName="uom"
                      (focus)="faSelect.open()"
                      panelWidth
                    >
                      <mat-option (click)="faSelect.close()">--</mat-option>
                      <mat-option *ngFor="let uom of uomValues" [value]="uom.key" (click)="faSelect.close()">
                        {{ uom.value }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <ng-container
                    *ngTemplateOutlet="
                      generalErrorMsgs;
                      context: { control: (floorFormArray | getFloorFGAt: floorIndex).controls.floorSize }
                    "
                  ></ng-container>
                </div>
              </div>
            </td>
            <td class="floor__size-uom" [class.disabled]="(floorFormArray | getFloorFGAt: floorIndex)?.value.hideFloor">
              <div class="floors__forms__item form-container">
                <div class="form-container__item optselect" formGroupName="floorHeight">
                  <input
                    miqOnlyNumbers
                    [restrictPaste]="false"
                    class="floor-size"
                    type="number"
                    min="0"
                    step="0.1"
                    name="floorHeight"
                    (blur)="formatNumericData(floorFormArray.controls[floorIndex])"
                    formControlName="val"
                  />
                  <mat-form-field
                    class="mat-select-field mat-form-field miq-form-input"
                    floatLabel="never"
                    appearance="outline"
                  >
                    <mat-select
                      hideSingleSelectionIndicator="true"
                      #faHeightSelect
                      [placeholder]="'commonLabels.select' | xTranslate"
                      panelClass="custom-dropdown"
                      name="floorHeightUOM"
                      formControlName="uom"
                      (focus)="faHeightSelect.open()"
                      panelWidth
                    >
                      <mat-option (click)="faHeightSelect.close()">--</mat-option>
                      <mat-option
                        *ngFor="let uom of distanceUOMValues"
                        [value]="uom.key"
                        (click)="faHeightSelect.close()"
                      >
                        {{ uom.value }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <ng-container
                    *ngTemplateOutlet="
                      generalErrorMsgs;
                      context: { control: (floorFormArray | getFloorFGAt: floorIndex).controls.floorHeight }
                    "
                  ></ng-container>
                </div>
              </div>
            </td>
            <td
              class="floor__add-remove"
              [class.disabled]="(floorFormArray | getFloorFGAt: floorIndex)?.value.hideFloor"
            >
              <span class="link-text">{{
                (floorFormArray | getFloorFGAt: floorIndex)?.controls.floorPlan.value.name
              }}</span>
            </td>
            <td>
              <span *ngIf="(floorFormArray | getFloorFGAt: floorIndex)?.value.hideFloor"
                ><mat-icon class="action-icon eye" svgIcon="hide-gray" aria-hidden="false"></mat-icon
              ></span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </form>
  <div class="button-container">
    <div class="error-msg-container">
      <ng-container *ngTemplateOutlet="generalErrorMsgs; context: { control: floorFormArray }"></ng-container>
    </div>
    <button
      mat-flat-button
      color="primary"
      type="button"
      [disabled]="floorsFG.invalid || floorsFG.pristine"
      (click)="saveFloorInfo()"
    >
      {{ 'commonLabels.save' | xTranslate }}
    </button>
  </div>

  <!-- FLOORS WITH CONFLICTS POPUP -->
  <ng-container *ngIf="conflictSpaces">
    <div class="faux-popup-backdrop" (click)="conflictSpaces = null"></div>
    <div class="faux-popup floors-with-conflicts">
      <mat-icon>error</mat-icon>
      <div class="conflicts-list">
        <p>{{ 'moreInfo.deleteFloorMsg' | xTranslate }}</p>
        <div>
          <ng-container *ngFor="let conflictSpace of conflictSpaces">
            <p>{{ 'commonLabels.floorNum' | xTranslate: { floorNumber: conflictSpace.floorNumber } }}</p>
            <ul>
              <li *ngIf="conflictSpace.elevatorStop">{{ 'errorMessages.elevatorStop' | xTranslate }}</li>
              <li *ngFor="let space of conflictSpace.spaces">
                <a *ngIf="space.spaceId !== nonRentableSpace; else plainLabel" [href]="space.url" target="_blank"
                  >#{{ space.spaceId }}</a
                >
                <ng-template #plainLabel>
                  {{ 'errorMessages.nonRentable' | xTranslate }}
                </ng-template>
              </li>
            </ul>
          </ng-container>
        </div>
      </div>
      <button mat-button color="warn" (click)="conflictSpaces = null">
        <mat-icon>close</mat-icon>
        {{ 'errorMessages.dismiss' | xTranslate }}
      </button>
    </div>
  </ng-container>

  <!-- DELETE FLOORS CONFIRMATION POP UP -->
  <ng-container *ngIf="confirmFloorsDelete">
    <div class="faux-popup-backdrop" (click)="confirmFloorsDelete = null"></div>
    <div class="faux-popup delete-confirmation">
      <h2>{{ 'commonLabels.confirmation' | xTranslate }}</h2>
      <p>
        <mat-icon>warning</mat-icon>
        {{ 'moreInfo.deleteConfirmation' | xTranslate }}
      </p>
      <div>
        <button mat-button color="primary" (click)="this.confirmFloorsDelete = false">
          {{ 'commonLabels.cancel' | xTranslate }}
        </button>
        <button mat-button color="warn" (click)="deleteFloorsTaskManager.next(true)">
          {{ 'commonLabels.delete' | xTranslate }}
        </button>
      </div>
    </div>
  </ng-container>

  <!-- GENERAL FORM ERROR MESSAGES -->
  <ng-template #generalErrorMsgs let-control="control">
    <div class="floors-inpur-error-wrapper">
      <ng-container *ngIf="control.errors">
        <!-- Pick first error from object -->
        <ng-container [ngSwitch]="(control.errors | keyvalue)[0].key">
          <span class="errorMsg" *ngSwitchCase="'required'">
            {{ 'moreInfo.valueCannotBeEmptyErrorMsg' | xTranslate }}
          </span>
          <span class="errorMsg" *ngSwitchCase="'max'">
            {{ 'moreInfo.maxNumberOfFloorsValMsg' | xTranslate: { maxValue: control.errors.max.max } }}
          </span>
          <span class="errorMsg" *ngSwitchCase="'min'">
            {{ 'moreInfo.minNumberOfFloorsValMsg' | xTranslate: { minValue: control.errors.min.min } }}
          </span>
          <!-- Custom form validations -->
          <span class="errorMsg" *ngSwitchCase="'notANumber'"> {{ 'moreInfo.onlyNumericValues' | xTranslate }} </span>
          <span class="errorMsg" *ngSwitchCase="'emptyUOM'"> {{ 'moreInfo.uomCannotBeEmpty' | xTranslate }} </span>
          <span class="errorMsg" *ngSwitchCase="'minFloorValidation'">
            {{
              'moreInfo.commonFloorShouldnotBLessThan'
                | xTranslate: { valueA: minFloorArea, uomA: minFloorAreaUOM | abbrevUom }
            }}
          </span>
          <span class="errorMsg" *ngSwitchCase="'minMaxValidation'">
            <span *ngIf="minFloorArea != null; else nullMinFloorView">
              {{
                'moreInfo.commonFloorBtwn'
                  | xTranslate
                    : {
                        valueA: minFloorArea,
                        uomA: minFloorAreaUOM | abbrevUom,
                        valueB: maxFloorArea,
                        uomB: maxFloorAreaUOM | abbrevUom,
                      }
              }}
            </span>
            <ng-template #nullMinFloorView>
              <span
                >{{
                  'moreInfo.commonFloorShouldnotBeMoreThan'
                    | xTranslate: { valueA: maxFloorArea, uomA: maxFloorAreaUOM | abbrevUom }
                }}
              </span>
            </ng-template>
          </span>
          <span class="errorMsg" *ngSwitchCase="'commonFloorAreaValidation'">
            {{ 'moreInfo.commonFloorShould' | xTranslate: { valueA: minFloorArea, uomA: minFloorAreaUOM | abbrevUom } }}
          </span>
          <span class="errorMsg" *ngSwitchCase="'emptyFloorNumber'">
            {{ 'moreInfo.valueCannotBeEmptyErrorMsg' | xTranslate }}
          </span>
          <span class="errorMsg" *ngSwitchCase="'duplicatedFloorNumber'">
            <ng-container *ngIf="control.errors.duplicatedFloorNumber?.value">
              Floor numbers cannot be duplicated:
              {{ control.errors.duplicatedFloorNumber.value }}
            </ng-container>
          </span>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!control.errors && control.warnings">
        <ng-container [ngSwitch]="(control.warnings | keyvalue)[0].key">
          <span class="warningMsg" *ngSwitchCase="'minGreaterThatMaxWarning'">{{
            'moreInfo.minFloorMax' | xTranslate
          }}</span>
          <span class="warningMsg" *ngSwitchCase="'required'">{{
            'moreInfo.valueCannotBeEmptyErrorMsg' | xTranslate
          }}</span>
          <span class="warningMsg" *ngSwitchCase="'min'">{{
            'moreInfo.minNumberOfFloorsValMsg' | xTranslate: { minValue: control.warnings.min.min }
          }}</span>
          <span class="warningMsg" *ngSwitchCase="'max'">{{
            'moreInfo.maxNumberOfFloorsValMsg' | xTranslate: { maxValue: control.warnings.max.max }
          }}</span>
          <span class="warningMsg" *ngSwitchCase="'minFloorValidation'">{{
            'moreInfo.commonFloorShouldnotBLessThan'
              | xTranslate: { valueA: minFloorArea, uomA: minFloorAreaUOM | abbrevUom }
          }}</span>
          <span class="warningMsg" *ngSwitchCase="'minMaxValidation'">
            <span *ngIf="minFloorArea != null; else warnNullMinFloor">{{
              'moreInfo.commonFloorBtwn'
                | xTranslate
                  : {
                      valueA: minFloorArea,
                      uomA: minFloorAreaUOM | abbrevUom,
                      valueB: maxFloorArea,
                      uomB: maxFloorAreaUOM | abbrevUom,
                    }
            }}</span>
            <ng-template #warnNullMinFloor
              ><span>{{
                'moreInfo.commonFloorShouldnotBeMoreThan'
                  | xTranslate: { valueA: maxFloorArea, uomA: maxFloorAreaUOM | abbrevUom }
              }}</span></ng-template
            >
          </span>
          <span class="warningMsg" *ngSwitchCase="'commonFloorAreaValidation'">{{
            'moreInfo.commonFloorShould' | xTranslate: { valueA: minFloorArea, uomA: minFloorAreaUOM | abbrevUom }
          }}</span>
        </ng-container>
      </ng-container>
    </div>
  </ng-template>
</ng-template>
